import type { AxiosError } from 'axios';
import type { ErrorResponseType } from './types';

import { CONTACT_EMAIL } from 'src/constants/contact';

class AxiosErrorController extends Error {
  status?: number;

  title?: string;

  apiStatusCode?: number;

  httpStatus?: number;

  timestamp?: string;

  constructor(e: unknown) {
    super((e as AxiosError<ErrorResponseType>).response?.data.message);

    const { status, title, apiStatusCode, timestamp } = e as ErrorResponseType;
    let { message } = e as ErrorResponseType;

    if (message === 'Network Error') {
      message = '';
    }

    this.title = title || '';
    this.message = (message || `알 수 없는 에러가 발생했어요.\n"${CONTACT_EMAIL}"으로 문의해주세요.`)
      + (apiStatusCode ? `\n(에러: ${apiStatusCode})` : '');
    this.status = status;
    this.apiStatusCode = apiStatusCode;
    this.timestamp = timestamp;

    Object.setPrototypeOf(this, AxiosErrorController.prototype);
  }
}

export default AxiosErrorController;
